import React, { useContext, useEffect } from 'react';
import { useImmer } from 'use-immer';
import _ from 'lodash';
//import PropTypes from 'prop-types';
import { useLocation } from "react-router-dom";
import { LinkContainer } from 'react-router-bootstrap';
import { Form, FormCheck } from 'react-bootstrap';

import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faChevronCircleRight } from "@fortawesome/free-solid-svg-icons"
import moment from 'moment';
import ConditionalRender from '../formControls/ConditionalRender';
import { CodingEventQueueContext } from '../../contexts/CodingEventQueueContext';
import ResultCountDisplay from '../table/ResultCountDisplay';

const CodingEventTable = (props) => {

    const [pageSize, setPageSize] = useImmer(30);
    //const [currentPage, setCurrentPage] = useImmer(0);
    //const [pagedResults, setPagedResults] = useImmer([]);
    const [descSearchText, setDescSearchText] = useImmer([]);
    const location = useLocation();
    //const userSelector = useSelector(state => state.applicationContext.filters.codingEventsFilters);

    const queueContext = useContext(CodingEventQueueContext);

//    useEffect(() => {
//        // when coding events change - 
//        // rechunk pagedResults
//        //const pagedResults = _.chunk(queueContext.codingEvents, pageSize);
//        //setPagedResults(pagedResults);
//        // reset page to first
///*        setCurrentPage(0);*/
//    }, [queueContext.codingEvents]);

    //useEffect(() => {
    //    if (props.pageSize !== pageSize) {
    //        setPageSize(props.pageSize);
    //    }
    //}, [props.pageSize]);

    useEffect(() => {
        if (queueContext.filters && queueContext.filters.searchText != descSearchText) {
            setDescSearchText(queueContext.filters.searchText);
        }
    }, [queueContext.filters]);

    const handlePage = (page) => {
        if (queueContext.currentPage !== page.selected) {
            queueContext.pageResults(page.selected);
        }
        window.scrollTo(0, 0);
    }

    const changeFilterIntInput = (event) => {
        const target = event.target;
        const value = isNaN(target.value) ? 0 : parseInt(target.value);
        const name = target.name;
        queueContext.setFilterValue(name, value);
    }

    const changeFilterInput = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        if (name === 'searchText') {
            setDescSearchText(value);
            if (value.length > 3) {
                queueContext.setFilterValue(name, value);
            } else if (queueContext.filters.searchText.length > 0) {
                queueContext.setFilterValue(name, '');
            }
        } else {
            queueContext.setFilterValue(name, value);
        }
    }

    return (
        <>
            { queueContext.filters ? <>
                <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <ConditionalRender visible={props.canBulkEdit && queueContext.editMode} >
                                <th></th>
                            </ConditionalRender>
                            <th>
                                <Form.Control
                                    type="numeric"
                                    value={queueContext.filters.searchId > 0 ? queueContext.filters.searchId : ''}
                                    style={{ width: "56px" }}
                                    className="form-control borderless-control"
                                    name="searchId" id="searchId"
                                    size="sm"
                                    placeholder="Id"
                                    onChange={changeFilterIntInput} />
                            </th>
                            <th>
                                <Form.Control value={descSearchText}
                                    className="borderless-control"
                                    name="searchText" id="searchText"
                                    size="sm" placeholder="Description"
                                    onChange={changeFilterInput} />
                            </th>
                            <th className={queueContext.filters.showCustomerQueue ? "d-none" : ""}>
                                <Form.Control as="select"
                                    value={queueContext.filters.accountId}
                                    className="borderless-control"
                                    name="accountId" id="accountId"
                                    size="sm"
                                    onChange={changeFilterIntInput
                                    }>
                                    {
                                        queueContext.refData.customerRefData.map((cust) => {
                                            return <option key={cust.id} value={cust.id}>{queueContext.filters.accountId === cust.id ? "Customer: " + cust.name + ' (' + cust.id + ')' : cust.name + ' (' + cust.id + ')'}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>
                                <Form.Control as="select"
                                    value={queueContext.filters.requestedServiceId}
                                    className="borderless-control"
                                    name="requestedServiceId" id="requestedServiceId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.requestedServiceRefData.map((service) => {
                                            return <option key={service.id} value={service.id}>{queueContext.filters.requestedServiceId === service.id ? "Service: " + service.name : service.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>
                                <Form.Control as="select"
                                    value={queueContext.filters.lineOfBusinessId}
                                    className="borderless-control"
                                    name="lineOfBusinessId" id="lineOfBusinessId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.lineOfBusinessRefData.map((lob) => {
                                            return <option key={lob.id} value={lob.id}>{queueContext.filters.lineOfBusinessId === lob.id ? "LOB: " + lob.name : lob.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th className={queueContext.filters.showTeamQueue || queueContext.filters.showMyQueue ? "d-none" : ""}>
                                <Form.Control as="select"
                                    value={queueContext.filters.queueId}
                                    className="borderless-control"
                                    name="queueId" id="queueId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.queueRefData.map((queue) => {
                                            return <option key={queue.id} value={queue.id}>{queueContext.filters.queueId === queue.id ? "Queue: " + queue.name : queue.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    value={queueContext.filters.eventPriorityId}
                                    name="eventPriorityId"
                                    id="eventPriorityId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.eventPriorityRefData.map((priority) => {
                                            return <option key={priority.id} value={priority.id}>{priority.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>Cust Priority</th>
                            <th>Due By</th>
                            <th className={queueContext.filters.showMyQueue ? "d-none" : ""}>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    value={queueContext.filters.assignedToId}
                                    name="assignedToId"
                                    id="assignedToId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.assignedToRefData.map((user) => {
                                            return <option key={user.id} value={user.id}>{queueContext.filters.assignedToId === user.id ? "Assigned To: " + user.name : user.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th className="no-padding-td">
                                <Form.Control as="select"
                                    className="borderless-control"
                                    value={queueContext.filters.statusId}
                                    name="statusId" id="statusId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.statusRefData.map((status) => {
                                            return <option key={status.id} value={status.id}>{queueContext.filters.statusId === status.id ? "Status: " + status.name : status.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th className="table-fit"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            queueContext.codingEvents.map((event, i) =>
                                <tr key={event.id} className={queueContext.selectedEvents.includes(event) ? "selectedRow" : ""}>

                                    <ConditionalRender visible={props.canBulkEdit && queueContext.editMode} >
                                        <td className="table-fit bg-lightgray givemethefinger" onClick={() => queueContext.selectEvent(event)}>
                                            <input type="checkbox" value={event.id} checked={queueContext.selectedEvents.includes(event)} />
                                        </td>
                                    </ConditionalRender>

                                    <td>{event.id}</td>
                                    <td style={{ width: "300px" }}>{event.description.length > 80 ? event.description.substring(0, 80) + ' ...' : event.description}</td>
                                    <td className={queueContext.filters.showCustomerQueue ? "d-none" : ""}>{event.customerAccountName}</td>
                                    <td>{event.serviceRequestName}</td>
                                    <td>{event.lineOfBusinessName}</td>
                                    <td className={queueContext.filters.showTeamQueue || queueContext.filters.showMyQueue ? "d-none" : ""}>{event.codingEventQueueName}</td>
                                    <td>{event.eventPriorityName}</td>
                                    <td>{event.customerPriorityName}</td>
                                    <td>{event.dueBy != null ? moment(event.dueBy).format('MM/DD/YYYY h:mm a') : ''}</td>
                                    <td className={queueContext.filters.showMyQueue ? "d-none" : ""}>{event.assignedToName}</td>
                                    <td>{event.statusName}</td>
                                    <td className="table-fit">
                                        {
                                            event.id != undefined ?
                                                <LinkContainer to={'/coding/event/' + event.id + '?returnUrl=' + encodeURIComponent(location.pathname)}>
                                                    <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                                                </LinkContainer> : null
                                        }
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                <ResultCountDisplay className="border-top" currentPage={queueContext?.filters?.currentPage} pageSize={queueContext?.filters?.take} currentResultCount={queueContext?.codingEvents?.length} totalResults={queueContext?.refData?.totalRecords} />
                {
                    queueContext.refData.totalRecords > queueContext.filters.take ?
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            //padding: 20,
                            boxSizing: 'border-box',
                            width: '100%',
                        }}>
                            <ReactPaginate
                                activeClassName={'pagination-item pagination-active '}
                                breakClassName={'pagination-item pagination-break-me '}
                                breakLabel={'...'}
                                containerClassName={'pagination-pagination'}
                                disabledClassName={'pagination-disabled-page'}
                                marginPagesDisplayed={2}
                                nextClassName={'pagination-item pagination-next '}
                                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                                onPageChange={handlePage}
                                forcePage={queueContext.filters.currentPage}
                                pageCount={Math.ceil(queueContext.refData.totalRecords / queueContext.filters.take)}
                                pageClassName={'pagination-item pagination-page '}
                                pageRangeDisplayed={2}
                                previousClassName={'pagination-item pagination-previous'}
                                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                            />
                        </div> : null
                }</> : null}
        </>
    );
}

export default CodingEventTable;